<template>
    <div v-if="loaded" class="create-site">
        <b-container fluid>
            <b-row>
                <b-col
                    cols="12"
                    lg="6"
                    offset-lg="3"
                >
                    <b-jumbotron>
                        <h3 class="text-center mb-3">
                            Crear Nuevo Sitio de {{ operativeWord }}
                        </h3>
                        <b-row class="my-3">
                            <b-col cols="12">
                                <b-button
                                    variant="info"
                                    class="mx-2"
                                    :to="{ name: 'home' }"
                                >
                                    <b-icon-arrow-bar-left /> Atrás
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <h5>
                                    Información de {{ operativeWord }}
                                </h5>
                                <p class="tall-line-height">
                                    <strong>Nombre:</strong> {{ targetCourse.name }}

                                    <span v-if="targetCourse.type !== 'Otra'">
                                        <br />
                                        <strong>Código:</strong> {{ targetCourse.code }}
                                    </span>
                                </p>
                                <hr />

                                <b-form @submit.stop.prevent="onSubmit">
                                    <b-form-group
                                        id="input-group-semester"
                                        label="*Semestre:"
                                        label-for="input-semester"
                                        description="Busque y haga click en una de las opciones que se despliegan para seleccionar el semestre deseado. Puede buscar por el año."
                                    >
                                        <VueBootstrapTypeahead
                                            id="input-semester"
                                            v-model.trim="semesterQuery"
                                            placeholder="Busque un semestre..."
                                            :minMatchingChars="2"
                                            :data="availableSemesters"
                                            :maxMatches="4"
                                            :serializer="semester => `${semester.academic_period}`"
                                            @hit="selectSemester($event)"
                                        />
                                    </b-form-group>

                                    <h4>
                                        <strong>Semestre seleccionado: </strong>
                                        <span v-if="selectedSemester">{{ selectedSemester.academic_period }}</span>
                                        <span v-else>Ninguno</span>
                                    </h4>

                                    <div class="text-center pt-4">
                                        <b-button
                                            type="submit"
                                            variant="primary"
                                            size="lg"
                                            :disabled="formDisabled || selectedSemester === null"
                                        >
                                            Crear Sitio
                                        </b-button>
                                    </div>
                                </b-form>
                            </b-col>
                        </b-row>
                    </b-jumbotron>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import VueBootstrapTypeahead from 'vue-typeahead-bootstrap'
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'CreateSite',
    components: {
        VueBootstrapTypeahead
    },
    data () {
        return {
            targetCourse: null,
            formDisabled: false,
            semesterQuery: '',
            selectedSemester: null,
            availableSemesters: [], // Retrieved dynamically from API
            loaded: false,
            semesterOptions: [],
            form: {
                semesterId: null
            }
        }
    },
    computed: {
        ...mapGetters([
            'getCourseByCode'
        ]),
        operativeWord () {
            if (this.targetCourse && this.targetCourse.type === 'Otra') {
                return 'Curso'
            }
            return 'Asignatura'
        }
    },
    watch: {
        async '$route' (to, from) {
            await this.loadSemesterOptions(to.params.courseCode)
        },
        semesterQuery (val, oldVal) {
            // Update the options every time the user changes the query.
            if (val) {
                this.getSemesterOptions(val)
            }
        }
    },
    methods: {
        ...mapActions([
            'readSemesterOptions',
            'createCourseSite',
            'getAllCourses',
            'readSitesRelatedToUser'
        ]),
        async loadSemesterOptions (courseCode) {
            this.loaded = false
            let loader = null
            try {
                this.targetCourse = this.getCourseByCode(courseCode)
                loader = this.$loading.show()
                this.loaded = true
                if (this.semesterOptions.length) {
                    this.form.semesterId = this.semesterOptions[0].value
                }
            } catch (error) {
                console.log({ error: error })
                this.$root.unknownErrorToast()
                this.loaded = false
            } finally {
                loader.hide()
            }
        },
        async getSemesterOptions (query) {
            let options = await this.readSemesterOptions({ academic_period: query, limit: 4 })
            this.availableSemesters = options
        },
        selectSemester (semester) {
            this.semesterQuery = ''
            this.form.semesterId = semester.id
            this.selectedSemester = semester
        },
        async onSubmit () {
            let loader = null
            const payloadData = { courseCode: this.targetCourse.code, semesterId: this.form.semesterId }
            try {
                this.formDisabled = true
                loader = this.$root.$loading.show()
                await this.createCourseSite(payloadData)
                await this.getAllCourses()
                await this.readSitesRelatedToUser() // This action reloads the user roles in their related sites.
                let academicPeriod = this.selectedSemester.academic_period
                this.$root.successToast(`El nuevo sitio para la asignatura "${this.targetCourse.name}" ha sido creado exitosamente.`)
                this.$router.push({ name: 'site', params: { courseCode: this.targetCourse.code, academicPeriod: academicPeriod } })
            } catch (err) {
                console.log({ error: err })
                if (err.response && err.response.status === 409) {
                    this.$root.dangerToast('Ya existe un sitio para esta asignatura y semestre. Intente con otro semestre.')
                } else {
                    this.$root.dangerToast('No se pudo crear el sitio. Vuelva a intentar, si el error persiste, comúniquese con el administrador de Portalasig')
                }
            } finally {
                this.formDisabled = false
                loader.hide()
            }
        }
    },
    async created () {
        await this.loadSemesterOptions(this.$route.params.courseCode)
    }
}
</script>
